export default {
    HERO: 'hero',
    DISPLAY: 'display',
    HEADLINE: 'headline',
    TITLE_1: 'title-1',
    TITLE_2: 'title-2',
    TITLE_3: 'title-3',
    UI_LARGE: 'ui-large',
    UI_BASELINE: 'ui-baseline',
    UI_SMALL: 'ui-small',
    UI_TINY: 'ui-tiny',
    CAPTION_TINY: 'caption-tiny',
    CAPTION_MICRO: 'caption-micro',
};
